/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { usePostBlogReadingTimeQuery } from "@/api/AppApi/services/blogs";
import BreadCrumb from "@/app/components/lib/breadcrumb/BreadCrumb";
import { PagesPaths } from "@/utils/functions/pages-paths";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  children: React.ReactNode;
  blogSlug: string;
  blogTitle: string;
}

const ClientBlogDetailsContainer: React.FC<props> = ({
  children,
  blogSlug,
  blogTitle,
}) => {
  const t = useTranslation();
  const [startTime, setStartTime] = useState<moment.Moment | null>(null);
  const postTimeReading = usePostBlogReadingTimeQuery({
    onError: (res) => {
      console.error(res);
    },
    onSuccess: () => {},
  });
  const submitSpendedTime = () => {
    if (startTime) {
      const endTime = moment();
      const duration = moment.duration(endTime.diff(startTime));
      const timeSpentInSeconds = duration.asSeconds();
      const RoundTimeSpentInSeconds = Math.round(timeSpentInSeconds);
      postTimeReading.mutate({
        blogSlug,
        body: { time: RoundTimeSpentInSeconds },
      });
    }
  };
  useEffect(() => {
    if (!startTime) setStartTime(moment());
    const beforeUnloadListener = (event: BeforeUnloadEvent) => {
      event.stopImmediatePropagation();
      submitSpendedTime();
    };
    window.addEventListener("beforeunload", beforeUnloadListener);
    return () => {
      submitSpendedTime();
      window.removeEventListener("beforeunload", beforeUnloadListener);
    };
  }, [startTime]);
  return (
    <>
      <BreadCrumb
        hierarchy={[
          { text: t.blog, link: PagesPaths.blog },
          { text: blogTitle },
        ]}
      />
      {children}
    </>
  );
};

export default ClientBlogDetailsContainer;
